import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames/bind';

import styles from './PublisherSelector.module.css';

import * as $auth from 'modules/auth';

const cls = classnames.bind(styles);

export const PublisherSelector = ({ className }) => {
  const dispatch = useDispatch();
  const user = useSelector($auth.getCurrentUser);
  const selectedPublisherID = useSelector($auth.getSelectedPublisherId);

  const publishers = user.publishers ?? [];

  return (
    <select
      value={selectedPublisherID ?? ''}
      onChange={(event) => {
        dispatch($auth.selectPublisherId(event.target.value));
      }}
      className={cls('select', className)}
    >
      {publishers.map((publisher) => (
        <option key={publisher.Id} value={publisher.Id}>
          {publisher.Name}
        </option>
      ))}
    </select>
  );
};
